// extracted by mini-css-extract-plugin
export var positionLeft = "e_M_cf";
export var positionRight = "e_M_cg";
export var screenTablet = "768px";
export var sectionContainer = "e_M_9";